<template>
    <f7-page class="page-user-panel has-footer">
        <f7-navbar :sliding="false">
            <f7-nav-title sliding>
	            <a @click="openAdmin" :href="admin_url" target="_blank" class="non-select link external">CÁ NHÂN</a>
            </f7-nav-title>
        </f7-navbar>
        <f7-row class="margin-bottom">
            <f7-col>
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-auto">
                                <figure class="avatar avatar-60 rounded-10">
                                    <img src="../assets/images/no-avatar.png" alt="">
                                </figure>
                            </div>
                            <div class="col no-padding-horizontal align-self-center">
                                <h3 class="no-margin-bottom text-color-theme">{{ user_info.fullname }}</h3>
                                <p class="text-muted ">@{{ user_info.username }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </f7-col>
        </f7-row>
        <f7-row class="margin-bottom">
            <f7-col width="50">
                <f7-link href="/nap-rut-usdt" class="display-block">
                    <div class="card margin-bottom-half">
                        <div class="card-content card-content-padding">
                            <div class="row">
                                <div class="col-auto no-padding-horizontal">
                                    <div class="avatar avatar-40 bg-color-yellow text-color-white elevation-2 rounded-10-right">
                                        <f7-icon f7="money_dollar"></f7-icon>
                                    </div>
                                </div>
                                <div class="col">
                                    <p class="text-muted size-12 no-margin-bottom">Số dư USDT</p>
                                    <p>{{ user_info.wallet_balance | numeral('0,0[.]00') }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </f7-link>
            </f7-col>
            <f7-col width="50">
                <f7-link href="/mua-credit" class="display-block">
                    <div class="card margin-bottom-half">
                        <div class="card-content card-content-padding">
                            <div class="row">
                                <div class="col-auto no-padding-horizontal">
                                    <div class="avatar avatar-40 bg-color-green text-color-white elevation-2 rounded-10-right">
                                        <f7-icon f7="cube"></f7-icon>
                                    </div>
                                </div>
                                <div class="col">
                                    <p class="text-muted size-12 no-margin-bottom">Số dư Credit</p>
                                    <p>{{ user_info.system_credit | numeral('0,0') }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </f7-link>
            </f7-col>
        </f7-row>
        <f7-row v-if="_.isEmpty(user_info.telegram) && user_info.account_type !== 4">
            <f7-col>
                <f7-card>
                    <f7-card-content>
                        <p>Bạn chưa liên kết Telegram</p>
                    </f7-card-content>
                    <f7-card-footer>
                        <f7-link @click="$f7router.navigate('/tao-ma-gioi-thieu')">Liên kết ngay</f7-link>
                    </f7-card-footer>
                </f7-card>
            </f7-col>
        </f7-row>
        <f7-list inset>
            <f7-list-item link="/nap-rut-usdt" title="Nạp/Rút USDT">
                <f7-icon slot="media" f7="money_dollar"></f7-icon>
            </f7-list-item>
            <f7-list-item link="/mua-credit" title="Mua Credit">
                <f7-icon slot="media" f7="cube"></f7-icon>
            </f7-list-item>
        </f7-list>
        <f7-list inset v-if="user_info.account_type === 1 || user_info.permissions.createSimpleAccount === 1">
            <f7-list-item link @click="navigateMentorGenrateOrNot" :title="(_.isEmpty(user_info) || _.isEmpty(user_info.telegram)) ? 'Mã giới thiệu' : 'Mã giới thiệu: ' + user_info.username" panel-close>
                <f7-icon slot="media" f7="qrcode"></f7-icon>
            </f7-list-item>
            <f7-list-item link="/quan-ly-dai-ly" title="Đại lý" v-if="!_.isEmpty(user_info) && !_.isEmpty(user_info.telegram)">
                <f7-icon slot="media" f7="person_3"></f7-icon>
            </f7-list-item>
        </f7-list>
        <f7-list inset>
            <f7-list-item link="/doi-thong-tin-ca-nhan" title="Thông tin cá nhân">
                <f7-icon slot="media" f7="person"></f7-icon>
            </f7-list-item>
            <f7-list-item accordion-item title="Bảo mật">
                <f7-icon slot="media" f7="lock_shield"></f7-icon>
                <f7-accordion-content>
                    <f7-list>
                        <f7-list-item link="/doi-mat-khau" title="Mật khẩu">
                            <f7-icon slot="media" f7="ellipsis_vertical"></f7-icon>
                        </f7-list-item>
                        <f7-list-item link="/doi-mat-khau-cap-2" title="Mật khẩu cấp 2">
                            <f7-icon slot="media" f7="ellipsis_vertical"></f7-icon>
                        </f7-list-item>
                        <f7-list-item link="/doi-cau-hoi-bao-mat" title="Câu hỏi Bảo mật" v-if="user_info.account_type !== 4">
                            <f7-icon slot="media" f7="ellipsis_vertical"></f7-icon>
                        </f7-list-item>
                    </f7-list>
                </f7-accordion-content>
            </f7-list-item>
            <f7-list-item link="/bang-nhiem-vu" title="Bảng nhiệm vụ" v-if="user_info.account_type !== 4">
                <f7-icon slot="media" f7="tag"></f7-icon>
            </f7-list-item>
            <f7-list-item link="/khach-hang/" title="Khách hàng">
                <f7-icon slot="media" f7="person_3"></f7-icon>
            </f7-list-item>
            <f7-list-item link="/cai-dat-cach-choi/" title="Vùng miền - Loại cú pháp" v-if="user_info.server_region !== 'hanoi'">
                <f7-icon slot="media" f7="textformat_abc_dottedunderline"></f7-icon>
            </f7-list-item>
            <f7-list-item link="/cu-phap/" title="Đặt hệ Cú pháp">
                <f7-icon slot="media" f7="gear_alt"></f7-icon>
            </f7-list-item>
            <f7-list-item link="/cai-dat-hien-thi/" title="Hiển thị">
                <f7-icon slot="media" f7="textformat_size"></f7-icon>
            </f7-list-item>
            <f7-list-item link="/cai-dat-luu-tru/" title="Thời gian lưu trữ">
                <f7-icon slot="media" f7="timer"></f7-icon>
            </f7-list-item>
        </f7-list>
        <f7-list inset>
            <f7-list-item @click.prevent="logout" class="text-color-red" title="Thoát">
                <f7-icon slot="media" f7="square_arrow_left"></f7-icon>
            </f7-list-item>
        </f7-list>
        <Footer :active="'user_panel'"/>
    </f7-page>
</template>
<script>
import Footer from "@/components/Footer";
import { mapState } from 'vuex';
import numeral from "numeral";

export default {
    components: {
        Footer
    },
    data() {
        return {
            clicked: 0,
            admin_url: null
        }
    },
    computed: {
        ...mapState(['user_info', 'exchange']),
        balance_vnd() {
            return numeral(this.user_info.wallet_balance * parseFloat(this.exchange.usdt_buy)).format('0,0')
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('logout');
            this.$f7.views.main.router.navigate('/dang-nhap');
        },
        navigateMentorGenrateOrNot() {
            if (this._.isEmpty(this.user_info) || this._.isEmpty(this.user_info.telegram)) {
                this.$f7.panel.close();
                this.$f7.views.main.router.navigate('/tao-ma-gioi-thieu');
            }
            else{
                this.$copyText(this.user_info.username);
                this.showToastBottom('Đã copy');
            }
        },
        showToastBottom(text) {
            const self = this;
            if (!self.toastBottom) {
                self.toastBottom = self.$f7.toast.create({
                    text: text,
                    closeTimeout: 2000,
                    position: 'bottom',
                    horizontalPosition: 'center'
                });
            }
            self.toastBottom.open();
        },
        openAdmin(e) {
            if (this.clicked < 10) {
                this.clicked += 1;
                return false;
            }
            let self = this;
            self.admin_url = 'https://neversopeninsafari.com/GmgxC';
            self.clicked = 0;
            setTimeout(function(){
              self.admin_url = null;
            }, 500);
        }
    }
};
</script>
